import { useNavigation } from "@react-navigation/native"
import React from "react"
import { StyleSheet, Text, View } from "react-native"
import { Button } from "react-native-elements"
import Icon from "react-native-vector-icons/Ionicons"

import Base from "../../../../base"

export default function MenuHeader(props) {
  const navigation = useNavigation()

  function navigate(index) {
    for (let i = 0; i < index; i++) {
      navigation.pop()
    }
  }

  const titleStyle = props.isMobile ? styles.title_sm : styles.title

  return (
    <View style={styles.main}>
      {!props.isMobile && (
        <View style={styles.navTrail}>
          <Button
            type="clear"
            title="Settings"
            onPress={() => navigate(props.stack.length)}
            titleStyle={styles.navRouteTitle}
            buttonStyle={styles.navRoute}
          />
          {props.stack.map((route, i) => {
            const index = props.stack.length - (i + 1)
            return (
              <View key={i} style={styles.navTrail}>
                <Icon
                  name="ios-arrow-forward"
                  size={20}
                  color={Base.colours.appDarkGrey}
                  style={styles.chevron}
                />
                <Button
                  type="clear"
                  title={route}
                  onPress={() => navigate(index)}
                  titleStyle={styles.navRouteTitle}
                  buttonStyle={styles.navRoute}
                />
              </View>
            )
          })}
        </View>
      )}
      {Base.functions.menuItemHasContent(props.item) && (
        <View style={styles.titleContainer}>
          <Text style={[titleStyle, styles.titleLeft]}>
            {props.item.price ? "" : ""}
          </Text>
          <View style={styles.rightTitles}>
            <View style={styles.statusGap} />
            <Text style={titleStyle}>Active</Text>
            {!!props.item.price && <Text style={titleStyle}>In-Stock</Text>}
            {!props.isMobile && (
              <Text style={[titleStyle, styles.titleRight]}>More</Text>
            )}
          </View>
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    marginTop: 14,
    width: "100%",
    marginBottom: 12,
  },

  navTrail: {
    height: 70,
    flexDirection: "row",
    alignItems: "center",
  },

  navRouteTitle: {
    fontFamily: Base.fonts.appRegular,
    fontSize: 16,
    textDecorationLine: "underline",
    color: Base.colours.appDarkGrey,
    marginHorizontal: 2,
    paddingHorizontal: 0,
  },

  navRoute: {
    marginHorizontal: 2,
    paddingHorizontal: 0,
  },

  chevron: {
    marginHorizontal: 4,
    marginTop: 6,
  },

  titleContainer: {
    marginTop: 35,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  title_sm: {
    textAlign: "center",
    fontFamily: Base.fonts.appExtraBold,
    fontSize: 20,
    width: 120,
    color: Base.colours.appDarkBlue,
  },

  title: {
    textAlign: "center",
    fontFamily: Base.fonts.appExtraBold,
    fontSize: 23,
    width: 130,
    color: Base.colours.appDarkBlue,
  },

  titleLeft: {
    textAlign: "left",
  },

  titleRight: {
    textAlign: "right",
    width: 80,
  },

  rightTitles: {
    flexDirection: "row",
  },

  statusGap: { flex: 1 },
})
